export default __webpack_public_path__ + "static/media/sus_dev_goal.8da2b846.jpg";